module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/127-sri-lanka-febdb5008ba2b188a16b100d52dd0bf7.svg";